/**
 * Toggle Elements on click
 * @module toggleElements
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

export const PLUGIN_NAME = 'toggleElements';
export const ACTIVE_CLASS = 'toggle-text--is-active';

export const DEFAULTS = {
  toggleElementDefault: '', // Corrected option names
  toggleElementAlt: '',     // Corrected option names
  toggleTextPoliteness: 'assertive',
};

/**
 * Add aria live attribute to targeted el
 * @param  {jQuery} $el - button /element that toggles text or elements
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setEventListeners = ($el, { toggleElementDefault, toggleElementAlt }) => {
  const toggleElements = () => {
    const isChecked = $el.is(':checked');
    const $defaultElement = $(`.${toggleElementDefault}`);
    const $altElement = $(`.${toggleElementAlt}`);

    if (isChecked) {
      $defaultElement.hide();
      $altElement.show();
    } else {
      $defaultElement.show();
      $altElement.hide();
    }

    $el.toggleClass(ACTIVE_CLASS);
  };

  $el.on('click.triggerElements', toggleElements);
  $el.on('change.triggerElements', toggleElements);
};

/**
 * Initializes the toggleElement or toggleElements.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function toggleElement(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}

registerJQueryPlugin(PLUGIN_NAME, toggleElement);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/toggle-elements.js